import { useState, useEffect, useCallback } from "react";
import { MAP_LAYERS } from "../../config/mapLayers";

const DEV_REFRESH_MS = 30_000;

async function computeMenuLayers() {
  const always = MAP_LAYERS.filter((l) => !l.overlayMenuRequiresMarkers);
  const gated = MAP_LAYERS.filter((l) => l.overlayMenuRequiresMarkers);
  const populated = [];
  for (const layer of gated) {
    try {
      const r = await fetch(layer.dataUrl, { cache: "no-store" });
      if (!r.ok) continue;
      const j = await r.json();
      if (Array.isArray(j.markers) && j.markers.length > 0) {
        populated.push(layer);
      }
    } catch {
      /* ignore */
    }
  }
  return [...always, ...populated];
}

function sameLayerMenu(a, b) {
  if (a.length !== b.length) return false;
  return a.every((layer, i) => layer.categoryId === b[i]?.categoryId);
}

/**
 * Layers for the CareMap "Map overlay" dropdown. Gated layers appear only after JSON has markers.
 * In development, re-probes periodically so a background scrape can add the option without reload.
 */
export function useMapOverlayMenuLayers() {
  const [menuLayers, setMenuLayers] = useState(() =>
    MAP_LAYERS.filter((l) => !l.overlayMenuRequiresMarkers)
  );

  const refresh = useCallback(() => {
    computeMenuLayers().then((next) => {
      setMenuLayers((prev) => (sameLayerMenu(prev, next) ? prev : next));
    });
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  useEffect(() => {
    if (process.env.NODE_ENV !== "development") return undefined;
    const id = window.setInterval(refresh, DEV_REFRESH_MS);
    return () => window.clearInterval(id);
  }, [refresh]);

  return menuLayers;
}
